<template>
  <span
    class="grid-square-weight-bar"
    v-bind:style="'width: ' + width + 'px'"
  ></span>
</template>

<script>
export default {
  name: 'grid-square-weight-bar',
  props: ['weight', 'shortDeck'],
  computed: {
    width: function () {
      if (!this.shortDeck) {
        return 25 * (this.weight / 100);
      }

      return this.weight * (30 / 100);
    },
  },
};
</script>

<style lang="scss" scoped>
  .grid-square-weight-bar {
    display: inline-block;
    position: absolute;
    height: 2px;
    bottom: 3px;
    left: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/grid-selector/grid-square-weight-bar.vue